export default __webpack_public_path__ + "static/media/egiro_step_2.2055b498.png";